import { useMemo } from 'react';
import { filterPendingOrdersByKeyword } from './pendingOrderKeywordMatch';
import { usePendingSearch } from './PendingSearchContext';

/** 当前待办列表按跨 Tab 关键词筛选 */
export const usePendingKeywordFilter = (orders) => {
	const { keyword } = usePendingSearch();
	const filteredOrders = useMemo(() => filterPendingOrdersByKeyword(orders, keyword), [orders, keyword]);
	const hasKeyword = Boolean(String(keyword).trim());
	return { keyword, hasKeyword, filteredOrders };
};
